import { finish, error } from '../../../modules/customers/actions/self-exclusion';

import api from '../../../api';

export function request(dispatch, { id, period }) {
    api.post('/customers/' + id + '/self-exclusion', { period }).then(
        () => api.get('/customers/' + id).then(
            (customer) => dispatch(finish(id, customer)),
            () => dispatch(finish(id))
        ),
        ({ errors }) => dispatch(error(id, errors))
    );
}
